module.exports = __webpack_public_path__ + "img/Assurance-Extra-Mortgage-Repayment.db74272b.jpg";